import { render, staticRenderFns } from "./VircosPrintHeader.vue?vue&type=template&id=6cfd5e35&scoped=true&"
import script from "./VircosPrintHeader.vue?vue&type=script&lang=js&"
export * from "./VircosPrintHeader.vue?vue&type=script&lang=js&"
import style0 from "./VircosPrintHeader.vue?vue&type=style&index=0&id=6cfd5e35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd5e35",
  null
  
)

export default component.exports